import React from 'react';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { map, join, get, last, isEmpty, find } from 'lodash';
import { getDisplayValue, castNumber } from 'resolvers/formatValue';
import { DATA_TYPES } from 'constants/common';
import { Icon } from 'modules/icon-bank';
import { Tooltip } from 'modules/tooltip';

import { minimalTabHeader as MinimalTabHeader } from 'ui/views/widgets/minimalTabHeader';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/member-coverage-info-list';
import { buttonPreloader as ButtonPreloader } from 'ui/views/generic/buttonPreloader';
import { useEffect, useState } from 'react';

 
const wellassistPlusImg = 'data:image/png;base64,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'
/*******************************/

// get field value view
const FieldView = ({ section, field, options } = {}) => {

    // address field type
    if (field.type === DATA_TYPES.ADDRESS) {

        // returned value is an array of string
        const displayValue = getDisplayValue({ type: field.type, value: section?.values && section.values[field.name] || "-" });

        return (
            <div className='ui-member-details-eligibility-widget__details__section-info__fields__item'>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__name'>{getLabel(field.title)}</div>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__value'>{join(displayValue, ', ')}</div>
            </div>
        );
    }

    /*------------*/

    // phone field type
    if (field.type === DATA_TYPES.PHONE) {

        // return value is an array of string
        const displayValues = getDisplayValue({ type: field.type, value: section.values && section.values[field.name] || "-" });

        return (
            <div className='ui-member-details-eligibility-widget__details__section-info__fields__item'>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__name'>{getLabel(field.title)}(M)</div> {/* implement `M` dynamically based on phone type */}
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__value'>{last(displayValues)}</div>
            </div>
        );
    }

    /*------------*/

    // organization field type
    if (field.type === DATA_TYPES.ORG) {

        // get organization name and organization code
        const [orgName, orgCode] = getDisplayValue({ type: field.type, value: section.values && section.values[field.name] || "-", returnType: DATA_TYPES.ARRAY });

        return (
            <div className='ui-member-details-eligibility-widget__details__section-info__fields__item'>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__name'>{getLabel(field.title)}</div>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__values'>

                    {/* organization name */}
                    <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__values__item'>{orgName}</div>

                    {/* organization code */}
                    {
                        !isEmpty(orgCode) ? (
                            <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__values__item ui-member-details-eligibility-widget__details__section-info__fields__item__values__item--small'>
                                ({orgCode})
                            </div>
                        ) : null
                    }
                </div>
            </div>
        );
    }

    /*------------*/

    // single-select field type
    if (field.type === DATA_TYPES.SINGLE_SELECT) {
        const displayValue = getDisplayValue({ type: field.type, value: section.values && section.values[field.name] || "-", options });

        return (
            <div className='ui-member-details-eligibility-widget__details__section-info__fields__item'>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__name'>{getLabel(field.title)}</div>
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__value'>{displayValue}</div>
            </div>
        );
    }

    /*------------*/

    // normal values
    const displayValue = getDisplayValue({ type: field.type, value: section.values && section?.values[field.name] || "-" });

    return (
        <Tooltip
            text={displayValue}
            activateOnOverflow={true}
            render={(binding = {}) => (
                <div className='ui-member-details-eligibility-widget__details__section-info__fields__item'>
                    <div className='ui-member-details-eligibility-widget__details__section-info__fields__item__name'>{getLabel(field.title)}</div>
                    <div {...binding} className='ui-member-details-eligibility-widget__details__section-info__fields__item__value ui-member-details-eligibility-widget__details__section-info__fields__item__value--truncate'>{displayValue}</div>
                </div>
            )}
        />
    );
};

// set display name
FieldView.displayName = 'memberDetailsEligibilityWidget.FieldView';

// default props
FieldView.defaultProps = {
    field: {},
    section: {},
    options: [],
};

/*------------------*/

// accumulator card view
const AccumulatorCard = ({ field, data } = {}) => {

    return (
        <div className='ui-member-details-eligibility-widget__details__accumulator-card'>

            {/* accumulator title */}
            {
                field.title ? (
                    <div className='ui-member-details-eligibility-widget__details__accumulator-card__title'>
                        {getLabel(field.title)}
                    </div>
                ) : null
            }

            {/* accumulator values */}
            <div className='ui-member-details-eligibility-widget__details__accumulator-card__values'>
                {
                    map([
                        { value: data.individual, title: 'displayTextIndividual', icon: 'individual' },
                        { value: data.family, title: 'displayTextFamily', icon: 'family' },
                    ], (consumption, consumptionIndex) => {

                        // consumption values
                        const consumed = castNumber({ value: consumption.value.consumed });
                        const limit = castNumber({ value: consumption.value.limit });
                        const consumptionPercentage = (consumed / limit) * 100;

                        return (
                            <div key={consumptionIndex} className='ui-member-details-eligibility-widget__details__accumulator-card__values__item'>

                                {/* title */}
                                <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__title'>
                                    <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__title__icon'>
                                        <Icon name={consumption.icon} />
                                    </div>
                                    <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__title__label'>
                                        {getLabel(consumption.title)}
                                    </div>
                                </div>

                                {/* amount */}
                                {
                                    0 === limit ? (
                                        <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__consumption'>
                                            {getDisplayValue({ type: DATA_TYPES.CURRENCY, value: consumed })}
                                        </div>
                                    ) : (
                                        <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__consumption'>
                                            {getDisplayValue({ type: DATA_TYPES.CURRENCY, value: consumed })} / {getDisplayValue({ type: DATA_TYPES.CURRENCY, value: limit })}
                                        </div>
                                    )
                                }

                                {/* consumption meter */}
                                {
                                    0 === limit ? null : (
                                        <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__meter'>
                                            <div className='ui-member-details-eligibility-widget__details__accumulator-card__values__item__meter__pill' style={{ width: `${consumptionPercentage}%` }} />
                                        </div>
                                    )
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

// set display name
AccumulatorCard.displayName = 'memberDetailsEligibilityWidget.AccumulatorCard';

// default props
AccumulatorCard.defaultProps = {
    field: {},
    data: {},
};

/*******************************/

// success view
const EMPTY_COVERAGE_VALUES = Object.freeze([]);

export const memberDetailsEligibilityWidgetSuccess = (props) => {

    const { tabsConfig = {}, memberInfo, tableResponse = [], actions = [] } = props;
    const selectedMemberInfo = memberInfo;

    const fetchAccumulatorInfo = find(actions, { name: 'fetchAccumulatorInfo' });
    const showAccumulatorInfo = !isEmpty(get(selectedMemberInfo, 'accumulatorInfo.values', {})) && !props.isFetchingAccumulatorInfo;
    const selectedCoverageInfo = tabsConfig?.selectedTab?.name === 'Mail Orders'
    ? get(selectedMemberInfo, 'mailOrderCoverageInfo', {})
     : get(selectedMemberInfo, 'coverageInfo', {});
    const coverageInfo = {
        ...selectedCoverageInfo,
        values: Array.isArray(selectedCoverageInfo?.values) ? selectedCoverageInfo.values : EMPTY_COVERAGE_VALUES,
    };
    const [flagValues, setFlagValues] = useState([]);
    useEffect(() => {
        setFlagValues(coverageInfo.values.map(() => false));
    }, [tabsConfig?.selectedTab?.name, coverageInfo.values]);
    return (
        <div className='ui-member-details-eligibility-widget'>

            {/* title */}
            <p className='ui-member-details-eligibility-widget__title'>
                {getLabel(props.title)}
            </p>

            {/* tab view */}

            {!isEmpty(tabsConfig.options) && (
                <MinimalTabHeader
                    tabs={tabsConfig.options}
                    selected={tabsConfig.selectedTab}
                    className={'ui-member-details-eligibility-widget__minimaltab'}
                    onChange={props.onTabChange}
                    {...props}
                />
            )}

            {'tabular' === get(selectedMemberInfo, 'view', 'default') ? (

                <TableSearchWidget
                    tableResponse={tableResponse}
                    templateType='inline'
                    layoutConfig={layoutConfig}
                    classNameTable={'ui-member-details-eligibility-widget__table-view'}
                    disablePagination={true}
                />

            ) : (

                <div className='ui-member-details-eligibility-widget__details'>

                    {/* member-info sections */}
                    {
                        map(tabsConfig?.selectedTab?.name === 'Mail Orders'
                            ? [get(props, 'epostBasicInfo', {}), coverageInfo]
                            : [get(props, 'basicInfo', {}), coverageInfo],
                             (section, sectionIndex) => {
                            
                            return (
                                <div key={sectionIndex} className='ui-member-details-eligibility-widget__details__section-info'>

                                    {/* section title */}
                                    {
                                        section.title ? (
                                            <div className='ui-member-details-eligibility-widget__details__section-info__title'>
                                                {getLabel(section.title)}
                                            </div>
                                        ) : null
                                    }

                                    {/* accordian */}
                                    {sectionIndex === 1 && <div>
                                        {section.values.map( (data, dataIndex) => {
                                            const finalData = { fields: section.fields, values: data, title: null }
                                            const fromDate = data?.fromDate;
                                            const toDate = data?.toDate;
                                            const accordionTitle = (tabsConfig?.selectedTab?.name === 'Mail Orders' && data.type && data.type !== "INACTIVE")
                                                ? data?.type
                                                : data?.carrier?.name;
                                            return <>
                                                <div
                                                    key={tabsConfig?.selectedTab?.name+dataIndex}
                                                    className='ui-member-details-listing__main__alerts__accordian__title-bar'
                                                    onClick={() => setFlagValues(previous =>
                                                        coverageInfo.values.map((_, index) =>
                                                            index === dataIndex ? !previous[index] : Boolean(previous[index])
                                                        )
                                                    )}
                                                >

                                                    <div className='ui-member-details-listing__main__alerts__accordian__title-bar__icon'>
                                                        <Icon id={ flagValues[dataIndex]   ? 'accordianDownArrow' : 'accordianRightArrow' } />
                                                    </div>
                                                    <div className='ui-member-details-accrodion-header'>
                                                        <div className='ui-member-details-listing-label-accordion'>
                                                            {accordionTitle}
                                                            {data.isWellAssistPlus && 
                                                                <img  className='ui-member-details-listing-img-accordion' src={wellassistPlusImg} />}
                                                        </div>
                                                        {(fromDate !== '-' && toDate !== '-') && <div style={{ paddingTop: 2 }} className='ui-member-details-listing-label-accordion'>
                                                           From {fromDate} To: {toDate}
                                                        </div>}
                                                    </div>
                                                </div>
                                                { flagValues[dataIndex] && <div className='ui-member-details-eligibility-widget__details__section-info__fields'>{map(finalData.fields, field => {
                                                    return (
                                                        <FieldView
                                                            key={field.name}
                                                            section={finalData}
                                                            field={field}
                                                            options={props.options[field.options]}
                                                        />
                                                    );
                                                })}
                                                </div>}
                                            </>
                                        })
                                        }
                                    </div>}

                                    {/* fields */}
                                    {sectionIndex == 0 && <div className='ui-member-details-eligibility-widget__details__section-info__fields'>
                                        {
                                            map(section.fields, field => {
                                                return (
                                                    <FieldView
                                                        key={field.name}
                                                        section={section}
                                                        field={field}
                                                        options={props.options[field.options]}
                                                    />
                                                );
                                            })
                                        }
                                    </div>}
                                </div>
                            );
                        })
                    }

                    {/* accumulators */}
                    {get(selectedMemberInfo, 'accumulatorInfo.showAccumulatorData', false) && tabsConfig?.selectedTab?.name !== 'Mail Orders' && (
                        <>

                            {
                                showAccumulatorInfo && map(get(selectedMemberInfo, 'accumulatorInfo.fields', []), (accumulatorField, accumulatorIndex) => {
                                    return (
                                        <AccumulatorCard
                                            key={accumulatorIndex}
                                            field={accumulatorField}
                                            data={get(selectedMemberInfo, `accumulatorInfo.values.${accumulatorField.name}`,)}
                                        />
                                    );
                                })
                            }

                            {fetchAccumulatorInfo && isEmpty(get(selectedMemberInfo, 'accumulatorInfo.values', {})) && (
                                <div className='ui-member-details-eligibility-widget__details__action' onClick={() => props.fetchAccumulatorInfo()}>

                                    {props.isFetchingAccumulatorInfo ? (

                                        <ButtonPreloader radius={props.radius} />

                                    ) : (

                                        getLabel(fetchAccumulatorInfo.title)

                                    )}
                                </div>
                            )}
                        </>
                    )}


                </div>

            )}
        </div>
    );
};

// set display name
memberDetailsEligibilityWidgetSuccess.displayName = 'memberDetailsEligibilityWidgetSuccess';

// set default props
memberDetailsEligibilityWidgetSuccess.defaultProps = {
    title: null,
    basicInfo: {
        title: null,
        values: {},
        fields: [],
    },
    memberInfo:
        {
            coverageInfo: {
                title: null,
                values: {},
                fields: [],
            },
            accumulatorInfo: {
                title: null,
                values: {},
                fields: [],
            }
        },
    options: [],
};

// prop types
memberDetailsEligibilityWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const memberDetailsEligibilityWidgetPreloader = () => {
    return (
        <div className='ui-member-details-eligibility-widget-preloader'>

            {/* head */}
            <div className='ui-member-details-eligibility-widget-preloader__head'>
                <div className='ui-member-details-eligibility-widget-preloader__head__title'></div>
            </div>

            {/* sections */}
            {
                map([1, 2], item => {
                    return (
                        <div key={item} className='ui-member-details-eligibility-widget-preloader__section'>
                            <div className='ui-member-details-eligibility-widget-preloader__section__title'></div>
                            <div className='ui-member-details-eligibility-widget-preloader__section__fields'>
                                {
                                    map([1, 2, 3, 4, 5, 6], _item => {
                                        return (
                                            <div key={_item} className='ui-member-details-eligibility-widget-preloader__section__fields__item'>
                                                <div className='ui-member-details-eligibility-widget-preloader__section__fields__item__name'></div>
                                                <div className='ui-member-details-eligibility-widget-preloader__section__fields__item__value'></div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    );
                })
            }

            {/* accumulators */}
            {
                map([1, 2], item => {
                    return (
                        <div key={item} className='ui-member-details-eligibility-widget-preloader__accumulator'></div>
                    );
                })
            }
        </div>
    );
};

// set display name
memberDetailsEligibilityWidgetPreloader.displayName = 'memberDetailsEligibilityWidgetPreloader';

// set default props
memberDetailsEligibilityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsEligibilityWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsEligibilityWidget as MemberDetailsEligibilityWidget } from 'ui/views/widgets/memberDetailsEligibilityWidget';
 *
 * // render
 * <MemberDetailsEligibilityWidget propName='propValue'/>
 */

export const memberDetailsEligibilityWidget = withNetworkState(memberDetailsEligibilityWidgetPreloader, memberDetailsEligibilityWidgetSuccess);
